<template>
    <section class="title2">
        <ogt-video ref="video" src="/static/video/carriere.mp4" poster="/static/video/carriere-poster.jpg"></ogt-video>

        <p>Hier werkten we aan in 2020 - onze 5 strategische doelen</p>

        <div class="list">
            <div class="point" @click="$router.push('/Onderwijskwaliteit')">
                <div class="number">1</div>
                <label>Aantoonbare <br/>onderwijs&shy;kwaliteit</label>
            </div>
            <div class="point active">
                <div class="number">2</div>
                <label>Opleiden voor <br/>een carri&egrave;re</label>
            </div>
            <div class="point" @click="$router.push('/Regio')">
                <div class="number">3</div>
                <label>Positie in <br class="hide-for-small" />de regio</label>
            </div>
            <div class="point" @click="$router.push('/Medewerker')">
                <div class="number">4</div>
                <label>Medewerker<br />3.0</label>
            </div>
            <div class="point" @click="$router.push('/Duurzaam')">
                <div class="number">5</div>
                <label>Duurzaam <br/>verbeteren</label>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
</style>

<script>
    import Tekst from '@/app/pages/carriere/Tekst';
    import Interview from '@/app/pages/carriere/Interview';
    import OgtVideo from '@/app/components/OgtVideo';

    import InterviewMohadesa from '@/app/pages/sub/InterviewMohadesa';

    export default {
        name: 'Carriere',
        meta: {
            title: '4.2 Opleiden voor een Carriére',
            color: '#FE5D0B',
            sub: true,
            slides: [Tekst, Interview]
        },

        components: {
            'ogt-video': OgtVideo
        },

        props: {
            meta: {
                default: () => {},
                type: Object
            }
        },

        mounted()
        {
        },

        methods: {
            focus()
            {
                this.$refs.video.play();
            },
            blur()
            {
                this.$refs.video.pause();
            },
            sub( name )
            {
                switch( name )
                {
                    case 'Mohadesa':
                        this.$emit( 'openOverlay', InterviewMohadesa, this.meta.index + 2 );
                        break;
                }
            }
        }
    };
</script>
